export default __webpack_public_path__ + "static/media/logo-EIT.46134938.svg";